import { FunctionComponent } from "react";

interface CustomActionsProps {}

let CustomActions: FunctionComponent<CustomActionsProps> = (props) => {
  return <div></div>;
};

export default CustomActions;
